import localAxios from  '@/services/axiosPermisos'

import {
    path
} from './path'


import {
    map_query
} from '@/core/functions/map-path-query'

async function getOperationsService () {
    return await localAxios.get(path.operations, true, 'v2')
}

async function getSitesService () {
    return await localAxios.get(path.sites, true, 'v2')
}

async function getReasonNamesService (data= {}) {
    return await localAxios.get(path.reasonNames.concat(map_query(data)), true, 'v2')
}

export {
    getOperationsService
    , getSitesService
    , getReasonNamesService
}